import Vue from "vue";
import VueRouter from "vue-router";
import axios from 'axios'; 

//import store from '../store';

Vue.use(VueRouter);

// Define your routes here
//import modal from  '../components/HelloWorld-modal.vue'
// Public homepage. The legacy `Home.vue` is kept on disk as a backup —
// swap this import to roll back if anything regresses.
import welcome from  '../views/Welcome.vue'
import form from  '../views/Form.vue'
import dashboard from  '../views/dashboard.vue'
import dashboardComposition from  '../views/dashboard-composition.vue'
import CompositionApiDemo from  '../components/CompositionApiDemo.vue'
import NotificationTemplates from  '../views/NotificationTemplates.vue'
import EmailBuilderDemo from  '../components/EmailBuilderDemo.vue'
import AdvancedEmailBuilder from  '../components/AdvancedEmailBuilder.vue'
import EmailTracking from  '../views/EmailTracking.vue'
import CommunicationTrackingView from  '../views/CommunicationTrackingView.vue'
import AdminDashboard from  '../views/AdminDashboard.vue'

const routes = [
    {
      path: '/',
      name: 'home',
      component: welcome
    },
    // Legacy preview paths now redirect to the canonical homepage so any
    // bookmarked / shared link keeps working.
    {
      path: '/home-draft',
      redirect: '/',
    },
    {
      path: '/draft',
      redirect: '/',
    },
    {
      path: '/account/:slug',
      name: 'account',
      component: form,
      beforeEnter: async (to, from, next) => {
        const slug = to.params.slug;
        try {
          // Assume checkSlugValidity is the API endpoint to check the slug validity
          const response = await axios.get(`https://engagrcdn.b-cdn.net/account/${slug}.json`);
          if (response.data) {
            next();
          } else {
            next('/');
          }
        } catch (error) {
          // Handle error, e.g., by redirecting to the home page
          next('/');
        }
      },
    },
    {
      path: '/account/:slug/dashboard',
      name: 'dashboard',
      component: dashboard,
      beforeEnter: async (to, from, next) => {
        const slug = to.params.slug;
        try {
          // Assume checkSlugValidity is the API endpoint to check the slug validity
          const response = await axios.get(`https://engagrcdn.b-cdn.net/account/${slug}.json`);
          if (response.data) {
            next();
          } else {
            next('/');
          }
        } catch (error) {
          // Handle error, e.g., by redirecting to the home page
          next('/');
        }
      },
    },
    {
      path: '/account/:slug/dashboard-composition',
      name: 'dashboard-composition',
      component: dashboardComposition,
      beforeEnter: async (to, from, next) => {
        const slug = to.params.slug;
        try {
          // Assume checkSlugValidity is the API endpoint to check the slug validity
          const response = await axios.get(`https://engagrcdn.b-cdn.net/account/${slug}.json`);
          if (response.data) {
            next();
          } else {
            next('/');
          }
        } catch (error) {
          // Handle error, e.g., by redirecting to the home page
          next('/');
        }
      },
    },
    {
      path: '/demo',
      name: 'demo',
      component: CompositionApiDemo
    },
    {
      path: '/email-builder-demo',
      name: 'email-builder-demo',
      component: EmailBuilderDemo
    },
    {
      path: '/email-builder',
      name: 'email-builder',
      component: AdvancedEmailBuilder
    },
    {
      path: '/account/:slug/notifications',
      name: 'notifications',
      component: NotificationTemplates,
      beforeEnter: async (to, from, next) => {
        const slug = to.params.slug;
        try {
          // Assume checkSlugValidity is the API endpoint to check the slug validity
          const response = await axios.get(`https://engagrcdn.b-cdn.net/account/${slug}.json`);
          if (response.data) {
            next();
          } else {
            next('/');
          }
        } catch (error) {
          // Handle error, e.g., by redirecting to the home page
          next('/');
        }
      },
    },
    {
      path: '/account/:slug/email-builder',
      name: 'account-email-builder',
      component: () => import('@/views/AccountEmailBuilder.vue'),
      beforeEnter: async (to, from, next) => {
        const slug = to.params.slug;
        try {
          // Check if the account slug is valid
          const response = await axios.get(`https://engagrcdn.b-cdn.net/account/${slug}.json`);
          if (response.data) {
            next();
          } else {
            next('/');
          }
        } catch (error) {
          // Handle error, e.g., by redirecting to the home page
          next('/');
        }
      },
    },
    {
      path: '/account/:slug/email-tracking',
      name: 'email-tracking',
      component: EmailTracking,
      beforeEnter: async (to, from, next) => {
        const slug = to.params.slug;
        try {
          // Check if the account slug is valid
          const response = await axios.get(`https://engagrcdn.b-cdn.net/account/${slug}.json`);
          if (response.data) {
            next();
          } else {
            next('/');
          }
        } catch (error) {
          // Handle error, e.g., by redirecting to the home page
          next('/');
        }
      },
    },
    {
      path: '/account/:slug/communication-tracking',
      name: 'communication-tracking',
      component: CommunicationTrackingView,
      beforeEnter: async (to, from, next) => {
        const slug = to.params.slug;
        try {
          // Check if the account slug is valid
          const response = await axios.get(`https://engagrcdn.b-cdn.net/account/${slug}.json`);
          if (response.data) {
            next();
          } else {
            next('/');
          }
        } catch (error) {
          // Handle error, e.g., by redirecting to the home page
          next('/');
        }
      },
    },
    {
      path: '/admin',
      name: 'admin',
      component: AdminDashboard,
      beforeEnter: async (to, from, next) => {
        // Check authentication using Better Auth
        try {
          const { auth } = await import('@/utils/betterAuth');
          const isAuthenticated = await auth.isAuthenticated();
          
          if (isAuthenticated) {
            next();
          } else {
            // Store the intended destination
            next({
              path: '/admin/login',
              query: { redirect: to.fullPath }
            });
          }
        } catch (error) {
          console.error('Auth check error:', error);
          next({
            path: '/admin/login',
            query: { redirect: to.fullPath }
          });
        }
      },
    },
    {
      path: '/admin/login',
      name: 'admin-login',
      component: () => import('@/components/BetterAuthLogin.vue'),
    },
    {
      path: '/blur-test',
      name: 'blur-test',
      component: () => import('@/views/BlurTest.vue'),
    },
    {
      // June 2026 blog — guerilla-styled "Why Your Welcome Still Matters
      // in the Age of AI Search" landing page, on the app's design system.
      path: '/blog/welcome-still-matters',
      name: 'blog-welcome-ai-search',
      component: () => import('@/views/BlogWelcomeAiSearch.vue'),
    },
    {
      // Engagr brand & design-system style guide — logo, colour, type,
      // the in-flight orbital motion, background-image recipe, components.
      path: '/style-guide',
      name: 'style-guide',
      component: () => import('@/views/StyleGuide.vue'),
    },
    {
      // ENGAGR Meta carousel (10 × 1080×1080) — Welcome Email social post,
      // built from the brief (Monday 12333272954) on the style-guide tokens.
      path: '/engagr-carousel',
      name: 'engagr-carousel',
      component: () => import('@/views/EngagrCarousel.vue'),
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: '/' // Redirecting to the home page
    }
  ];
  
  
  const router = new VueRouter({
    base: process.env.BASE_URL,
    routes, // Register your routes here
    mode: 'history' // Choose the mode (history or hash) for routing
  })


  export default router;
